// Shared Y.E.S (Youth Employment Service) display helpers.
// The `yes` block on the /core/scorecard/combined-total/ response is produced by
// backend `_apply_yes_recognition`; `level` / `combined_points` on that response are
// already post-YES, so "level without YES" is reconstructed by shifting back down.

export const YES_LEVEL_ORDER = [
  'Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5', 'Level 6', 'Level 7', 'Level 8', 'Non-Compliant',
];

// The scorecard level before YES recognition was applied.
export const levelWithoutYes = (level, levelsGained = 0) => {
  const i = YES_LEVEL_ORDER.indexOf(level);
  if (i === -1 || !levelsGained) return level;
  return YES_LEVEL_ORDER[Math.min(i + levelsGained, YES_LEVEL_ORDER.length - 1)];
};

// Why recognition was not awarded — plain-language, client-facing.
export const YES_BLOCKED_REASONS = {
  not_registered: 'Not registered for Y.E.S',
  prior_level_not_maintained: 'Prior B-BBEE level not maintained',
  no_target: 'Y.E.S target could not be calculated',
  below_lowest_tier: 'Target or absorption rate not yet met',
};

export const YES_WARNINGS = {
  absorption_not_yet_verifiable:
    'Absorption rate not verifiable yet — no placement has finished its programme. This does not hold back recognition for now.',
};

// "+N levels · +M bonus points" — null when nothing was gained.
export const yesGainLabel = (yes) => {
  if (!yes?.qualifies_for_recognition) return null;
  const parts = [];
  if (yes.levels_gained) parts.push(`+${yes.levels_gained} level${yes.levels_gained === 1 ? '' : 's'}`);
  if (yes.bonus_points_gained) parts.push(`+${yes.bonus_points_gained} bonus point${yes.bonus_points_gained === 1 ? '' : 's'}`);
  return parts.join(' · ') || null;
};

export const fmtAbsorption = (n) => `${(Math.round((n || 0) * 10) / 10).toFixed(1)}%`;
